import React from 'react';
import { TopBar } from './components/TopBar';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { ProductIntro } from './components/ProductIntro';
import { MethodPillars } from './components/MethodPillars';
import { WhatsIncluded } from './components/WhatsIncluded';
import { TransformationSection } from './components/TransformationSection';
import { AudienceSection } from './components/AudienceSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { FloatingCTA } from './components/FloatingCTA';
export function App() {
  return <div className="min-h-screen w-full" data-id="element-0">
      <TopBar data-id="element-1" />
      <FloatingCTA data-id="element-2" />
      <HeroSection data-id="element-3" />
      <ProblemSection data-id="element-4" />
      <ProductIntro data-id="element-5" />
      <MethodPillars data-id="element-6" />
      <WhatsIncluded data-id="element-7" />
      <TransformationSection data-id="element-8" />
      <AudienceSection data-id="element-9" />
      <GuaranteeSection data-id="element-10" />
      <FinalCTA data-id="element-11" />
      <Footer data-id="element-12" />
    </div>;
}